import { Loader } from '../Common/Loader/loader';
import { FaArrowLeft } from 'react-icons/fa';
import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '@mui/material/styles';
import DoneIcon from '@mui/icons-material/Done';
import Accordion from "@mui/material/Accordion";
import DialogBox from '../Common/DialogBox/dialogBox';
import { useDispatch, useSelector } from 'react-redux';
import AuthModals from '../Common/AuthModals/authModals';
import profileVector from '../../Assets/Images/vector.png'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClassesList from '../Common/ClassesList/classesList';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import courseVector from '../../Assets/Images/courseVector.png'
import { specialFont } from '../../Infrastructure/Theme/fontFamily'
import { trackEvent } from '../../Infrastructure/Utilities/analytics';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SHOW_RATINGS } from '../../Infrastructure/Constants/ratingsState';
import useClassCount from '../../Infrastructure/CustomHooks/useClassCount';
import useServerClock from '../../Infrastructure/CustomHooks/useServerClock';
import useAuthentication from '../../Infrastructure/States/onAuthStateChange';
import useGetClassDate from '../../Infrastructure/CustomHooks/useGetClassDate';
import AnalyticsConstants from '../../Infrastructure/Constants/AnalyticsContants';
import { cleanCourseState, setCourseDetails } from '../../Infrastructure/States/courseDetailsSlice';
import { Box, Typography } from '@mui/material';
import { chooseModalEmailVerify, chooseModalLogin } from '../../Infrastructure/States/authModalsSlice';
import { USER_LOGS_CLIENT } from '../../Infrastructure/Constants/logsConstant';
import { convertTimestampToDay } from '../../Infrastructure/Utilities/convertTimestampToDay';
import CourseListingCard from '../Common/CourseListingCard/courseLisingCard';
import paths from '../../Infrastructure/Router/paths';
import { safeClientLogEvent } from '../../Infrastructure/Utilities/safeClientLogEvent';
import courseListingStyles from './styles';

export const CourseListing = ({ centerLoader = false, live=false, dashboardState, setCourse, isCoursePage }) => {
    const data = useParams()
    const theme = useTheme()
    const boxRef = useRef(null)
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const serverTime = useServerClock();
    const paramsTitleUrl = data && data?.title
    const { user, loading, userId } = useAuthentication();
    const [open, setOpen] = useState(false);
    const [imageError, setImageError] = useState(false)
    const [message, setMessage] = useState(null);
    const [verified, setVerified] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [avatarLoaded, setAvatarLoaded] = useState(false);
    const [classSchedule, setClassSchedule] = useState(null);
    const [authenticated, setAuthenticated] = useState(false);
    const [classesLoading, setClassesLoading] = useState(false);
    const [checkingVisible, setCheckingVisible] = useState(true);
    const chooseModal = useSelector((state) => state.auth.chooseModal);
    const coursesData = useSelector((state) => state.userData.coursesData)
    const userData = useSelector((state) => state.userData.data)
    const loader = useSelector((state) => state.userData.loading)
    const course = useSelector((state) => state.course.courseDetails)
    const ip = useSelector((state) => state.ip.address)
    const avatar = course?.course?.user?.educator?.profile?.avatar ? course?.course?.user?.educator?.profile?.avatar : userData?.educator?.profile?.avatar
    const firstName = course?.course?.user?.account?.first_name ? course?.course?.user?.account?.first_name : userData?.account?.first_name
    const lastName = course?.course?.user?.account?.last_name ? course?.course?.user?.account?.last_name : userData?.account?.last_name
    const profileUrl = course?.course?.user?.educator?.url ? course?.course?.user?.educator?.url : userData?.educator?.url
    const title = course?.course?.courseDetails?.basics?.title
    const cost = course?.course?.courseDetails?.basics?.cost
    const classScheduleObj = course?.course?.courseDetails?.class_schedule;
    const classScheduleRef = useRef(classScheduleObj)
    const cardRef = useRef(null);
    const [cardHeight, setCardHeight] = useState(0);
    const courseListingSx = courseListingStyles(dashboardState, cardHeight, isCoursePage)

    const firstClassScheduleKey = classSchedule && Object.keys(classSchedule).find(key => live ? classSchedule[key].status === 'active' : true);
    const firstClassSchedule = firstClassScheduleKey && classSchedule[firstClassScheduleKey];
    // call the hook to get the first class total enrolled number
    const { classCount, countLoading } = useClassCount(firstClassScheduleKey, live);
    const first_class = parseInt(firstClassSchedule?.first_class, 10)
    const duration = firstClassSchedule?.duration
    const times = firstClassSchedule?.times
    const objectives = course?.course?.courseDetails?.intended_learner?.objectives
    const prerequisites = course?.course?.courseDetails?.intended_learner?.prerequisites
    const intended_learner = course?.course?.courseDetails?.intended_learner?.description
    const courseImage = course?.course?.courseDetails?.details?.course_image
    const description = course?.course?.courseDetails?.details?.description
    const curriculum = course?.course?.courseDetails?.curriculum?.sections
    const { weekday, month, year } = useGetClassDate(first_class);
    const educator_id = course?.course?.user?.educator_id
    const firstClassKey = classSchedule && Object.keys(classSchedule)[0];
    const maxLearners = classSchedule && classSchedule[firstClassKey]?.max_learners;
    const courseId = course?.courseId
    const isEducator = userData && userData?.is_educator
    const courseUrl =
        courseId &&
        isEducator &&
        userData?.educator?.courses &&
        Object.keys(userData.educator.courses).length > 0 &&
        userData.educator.courses[courseId]?.courseDetails?.url;
    useEffect(() => {
        classScheduleRef.current = classScheduleObj;
    }, [classScheduleObj]);
    const handleClick = async () => {
        try {
            trackEvent(AnalyticsConstants.MORE_SCHEDULES_VIEWED, {
                courseId,
                CourseTitle: title,
                courseUrl
            });
         } catch (trackingError) {
            await safeClientLogEvent({
              ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
              uid: userId || null,
              source: "courseListing.jsx",
              emailInfo: null,
              metadata: null,
              error: trackingError?.message || null
            });
         }
        boxRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const formatSchedule = () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (times) {
            const dayGroups = {};
            Object.entries(times).forEach(([timestamp, { start, end }]) => {
                const dayName = convertTimestampToDay(timestamp)
                const formattedStart = convertToLocalStartTime(start, timezone);
                const formattedEnd = convertToLocalEndTime(end, timezone);
                const timeRange = `${formattedStart} - ${formattedEnd}`
    
                if (!dayGroups[dayName]) {
                    dayGroups[dayName] = [];
                }
                dayGroups[dayName].push(timeRange);
            })
            const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
            const sortedDays = Object.keys(dayGroups).sort((a, b) => {
                return dayOrder.indexOf(a) - dayOrder.indexOf(b);
            })
            const formattedSchedule = sortedDays.map((dayName) => {
                const capitalizedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1);
                const times = dayGroups[dayName];
                if (times.length > 1) {
                    return `${capitalizedDay}: ${times.join(', ')}`;
                } else {
                    return `${capitalizedDay}: ${times[0]}`;
                }
            });
            return formattedSchedule;
        }
        return ['No schedule available'];
    };
    const handleMessageDialogBox = (isEducator, isEnrolledClass) => {
        if (isEducator) {
            setMessage("Educators cannot enroll in courses")
        } else if (isEnrolledClass === "enrolled" || isEnrolledClass === "enrolledInAnotherClass") {
            setMessage("You're already enrolled")
        }
    }
    const handleEnrolledCourse = async (classId) => {
        if (!authenticated) {
            dispatch(chooseModalLogin())
            return
        }
        if (!verified) {
            dispatch(chooseModalEmailVerify())
            return
        }
        const classes = Object.values(userData?.student?.classes ?? {})
        const isAlreadyEnrolled = classes.some(db_class =>
            db_class?.course_id === course?.courseId &&
            db_class?.class_id === classId &&
            db_class?.payment_status !== 'failed' &&
            db_class?.payment_status !== 'refunded'
        )
        if (isAlreadyEnrolled) {
            handleMessageDialogBox(isEducator, "enrolled")
            setOpen(true)
            return
        }
    const hasActiveEnrollment = classes.some(db_class =>
        db_class?.course_id === course?.courseId &&
        (db_class?.payment_status === 'success' || db_class?.payment_status === 'pending')
    )

    if (hasActiveEnrollment) {
        handleMessageDialogBox(isEducator, "enrolledInAnotherClass")
        setOpen(true)
        return
    }

    if (!isEducator) {
            try {
                trackEvent(AnalyticsConstants.ENROLL_BUTTON_CLICKED, {
                    classId,
                    courseId,
                    CourseTitle: title,
                    courseUrl
                });
              } catch (trackingError) {
                await safeClientLogEvent({
                  ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
                  uid: userId || null,
                  source: "courseListing.jsx",
                  emailInfo: null,
                  metadata: null,
                  error: trackingError?.message || null
                });
              }
            navigate(paths.checkoutPage.path, { state: { educator_id, course_id: courseId, from: location.pathname, classId } });
        } else {
            handleMessageDialogBox(isEducator, "notEnrolled")
            setOpen(true)
        }
    }
    const convertToLocalStartTime = (timestamp, userTimezone) => {
        const date = new Date(timestamp);
        const options = { hour12: true, hour: 'numeric', minute: 'numeric', timeZone: userTimezone };
        return date.toLocaleString('en-US', options);
    };
    const convertToLocalEndTime = (timestamp, userTimezone) => {
        const date = new Date(timestamp);
        const options = { hour12: true, hour: 'numeric', minute: 'numeric', timeZone: userTimezone };
        return date.toLocaleString('en-US', options);
    };
    const classTimes = formatSchedule()

    useEffect(() => {
        if (course?.courseId && userData && userData.educator && userData.educator.courses) {
            let newCourseId = course?.courseId;
            const courseData = userData.educator?.courses[newCourseId ? newCourseId : ''];
            if (courseData) {
                dispatch(setCourseDetails({ course: courseData, courseId: newCourseId }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
    const checkCourse = async () => {
        setCheckingVisible(true);
        if (live && coursesData && Object.keys(coursesData).length === 0) {
        navigate("/courses");
        setCheckingVisible(false);
        return;
        }
        // If there are courses and a param in URL
        if (paramsTitleUrl && coursesData && Object.keys(coursesData).length > 0) {
        const smallLettersParamTitle = paramsTitleUrl.toLowerCase();
        const foundCourse = Object.values(coursesData).find(
            (course) => course?.url?.toLowerCase() === smallLettersParamTitle && course?.visible === true
        );

                if (foundCourse) {
                    const courseId = Object.keys(coursesData).find(key => coursesData[key] === foundCourse)
                    dispatch(setCourseDetails({ course: foundCourse, courseId: courseId }));
                } else {
        await safeClientLogEvent({
                    ...USER_LOGS_CLIENT.COURSE_NOT_FOUND,
                    uid: userId || null,
                    source: "courseListing.jsx",
                    emailInfo: null,
                    metadata: { paramsTitleUrl },
                    error: null
                    });
                    navigate("*")
        }
        }
        setCheckingVisible(false);
    }
      checkCourse();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [coursesData, paramsTitleUrl, userId, ip]);
    useEffect(() => {
        if (!loading) {
            setAuthenticated(user);
            setVerified(userData?.email_verified);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, user, userData?.email_verified])
   
    useEffect(() => {
    if (cardRef.current) {
        setCardHeight(cardRef.current.offsetHeight);
    }
    }, [classSchedule, imageLoaded, avatarLoaded])
    // // Remove past classes
    useEffect(() => {
        const filterClasses = async () => {
            try {
                setClassesLoading(true);
                const currentTime = serverTime || Date.now()
                const currentClassScheduleObj = classScheduleRef.current
                if (!currentTime || !currentClassScheduleObj) return
                if (!isCoursePage) {
                    setClassSchedule(currentClassScheduleObj);
                    setClassesLoading(false);
                    return;
                }
                const filteredSchedule = Object.keys(currentClassScheduleObj)
                    .filter((key) => {
                        const classItem = currentClassScheduleObj[key]
                        const expireTime = classItem.class_expiration_time
                        if (classItem?.visible === false) return false
                        if (classItem?.status !== "active") return false
                        return currentTime <= expireTime
                    })
                    .reduce((acc, key) => {
                        acc[key] = currentClassScheduleObj[key];
                        return acc;
                    }, {});
                setClassSchedule(filteredSchedule);
            } catch (error) {
                await safeClientLogEvent({
                  ...USER_LOGS_CLIENT.SERVER_TIME_FETCH_FAILED,
                  uid: userId || null,
                  source: "courseListing.jsx",
                  emailInfo: null,
                  metadata: null,
                  error: error?.message || null
                });
                return null
            } finally {
                setClassesLoading(false);
            }
        }
        filterClasses();
    }, [classScheduleObj, isCoursePage, dashboardState, ip, userId, serverTime]);

    if (loading || loader || classesLoading || checkingVisible) {
        return <Loader height= { centerLoader ? "100%" : "100vh" } />
    }
    return (
        <>
            <DialogBox open={open} setOpen={setOpen} coursesPage={true} message={message} />
            <AuthModals chooseModal={chooseModal} />
            <Box
                sx={courseListingSx.root}>
                {
                    loader ? <Loader /> :
                        <Box
                            sx={courseListingSx.content}
                        >
                            <Box ref={cardRef} sx={courseListingSx.courseCardBox}>
                                {
                                    dashboardState &&
                                    <Box sx={courseListingSx.backArrow}><FaArrowLeft
                                        onClick={() => { setCourse(null); dispatch(cleanCourseState()); }}
                                    /></Box>
                                }
                                <CourseListingCard
                                    title={title}
                                    firstName={firstName}
                                    lastName={lastName}
                                    avatar={avatar}
                                    profileVector={profileVector}
                                    courseImage={courseImage}
                                    courseVector={courseVector}
                                    profileUrl={profileUrl}
                                    imageError={imageError}
                                    setImageError={setImageError}
                                    specialFont={specialFont}
                                    imageLoaded={imageLoaded}
                                    setImageLoaded={setImageLoaded}
                                    avatarLoaded={avatarLoaded}
                                    setAvatarLoaded={setAvatarLoaded}
                                    classSchedule={classSchedule}
                                    classesLoading={classesLoading}
                                    month={month}
                                    weekday={weekday}
                                    year={year}
                                    classTimes={classTimes}
                                    duration={duration}
                                    cost={cost}
                                    handleEnrolledCourse={handleEnrolledCourse}
                                    firstClassScheduleKey={firstClassScheduleKey}
                                    isCoursePage={isCoursePage}
                                    countLoading={countLoading}
                                    classCount={classCount}
                                    maxLearners={maxLearners}
                                    live={live}
                                    handleClick={handleClick}
                                    SHOW_RATINGS={SHOW_RATINGS}
                                    navigate={navigate}
                                    theme={theme}
                                    dashboardState={dashboardState}
                                />
                            </Box>
                            <Box sx={courseListingSx.contentBox}>
                                {objectives && <Box
                                    sx={courseListingSx.objectivesMainBox}
                                >
                                    <Typography variant="h6" fontFamily={specialFont} color={'primary'}
                                        sx={courseListingSx.objectivesTitle}>
                                        Learning Objectives
                                    </Typography>
                                    <Box
                                        sx={courseListingSx.objectivesSecondMainBox}
                                    >
                                        {Object.keys(objectives).map((key) => (
                                            objectives[key] && (
                                                <Box key={key} sx={courseListingSx.objectivesBox}>
                                                    <DoneIcon sx={courseListingSx.doneIcon} />
                                                    <Typography
                                                        key={key}
                                                        sx={courseListingSx.objectiveText}
                                                    >
                                                        {objectives[key]}
                                                    </Typography>
                                                </Box>
                                            )
                                        ))}
                                    </Box>
                                </Box>}
                                {curriculum && <Box sx={courseListingSx.curriculumMainBox} >
                                    <Typography variant="h6" color={'primary'} sx={courseListingSx.curriculumTitle}>
                                        Curriculum
                                    </Typography>
                                    {curriculum.map((item, index) => (
                                        <Accordion key={index} sx={courseListingSx.curriculumAccordion}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon fontSize="small" />}
                                                aria-controls={`panel${index + 1}-content`}
                                                id={`panel${index + 1}-header`}
                                            >
                                                <Typography variant="subtitle1" fontSize={15}>
                                                    {item.title}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography variant="subtitle2" fontSize={15}>{item.description}</Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Box>}
                                {prerequisites && <Box sx={courseListingSx.prerequisitesMainBox}>
                                    <Typography variant="h6" color={'primary'} sx={courseListingSx.prerequisitesTitle}>
                                        Requirements
                                    </Typography>
                                    <ul style={{ listStyleType: 'disc', }}>
                                        {Object.keys(prerequisites).map((key) => (
                                            <li key={key} style={{ fontSize: '15px', }}>
                                                {prerequisites[key]}
                                            </li>
                                        ))}
                                    </ul>
                                </Box>}
                                {description && <Box
                                    sx={courseListingSx.descriptionMainBox}
                                >
                                    <Typography variant="h6" color={'primary'} sx={courseListingSx.descriptionTitle} >Description</Typography>
                                    <Box fontSize='15px' dangerouslySetInnerHTML={{ __html: description }} />
                                </Box>}
                                {intended_learner && <Box
                                    sx={courseListingSx.intendedLearnerMainBox}
                                >
                                    <Typography variant="h6" color={'primary'} sx={courseListingSx.intendedLearnerTitle}>Who this course is for</Typography>
                                    <p style={{ fontSize: "15px" }}>{intended_learner}</p>
                                </Box>}
                                <Box
                                    ref={boxRef}
                                    sx={courseListingSx.cohortBox}
                                >
                                    <Typography variant="h6"  color={'primary'}
                                        sx={courseListingSx.cohortTitle}>
                                        Cohort Schedule
                                    </Typography>
                                    <Box
                                        sx={courseListingSx.cohortClassesList}
                                    >
                                        <ClassesList classSchedule={classSchedule} live={live} dashboardState={dashboardState} isCoursePage={isCoursePage} handleEnrolledCourse={handleEnrolledCourse} convertToLocalStartTime={convertToLocalStartTime} convertToLocalEndTime={convertToLocalEndTime} />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                }
            </Box>
        </>)
}